<template>
  <div id="contenedor-insumos-default">
    <v-container fluid>
      <v-card
        class="mb-4"
        flat>
        <v-card-text>
          <titulo-tool-bar class="mb-2" titulo="Insumos"></titulo-tool-bar>
          <tool-bar
            class="mb-4"
            :filtros="filtros"
            v-on:nuevoInsumo="registrarNuevoInsumo"
            >
          </tool-bar>
        </v-card-text>
      </v-card>
      <v-card flat>
        <v-card-text>
          <listado :listadoInsumos="getCatalogoInsumos"></listado>
        </v-card-text>
      </v-card>
    </v-container>
    <v-dialog
      v-if="mostrarVentanaRegistrarNuevoInsumo"
      v-model="mostrarVentanaRegistrarNuevoInsumo"
      :width="!$vuetify.breakpoint.xs ? '700' : '90%'">
      <registrar-nuevo-insumo
        v-on:cerrar="cerrarVentana">
      </registrar-nuevo-insumo>
    </v-dialog>
    <v-dialog
      v-if="esteInsumo"
      v-model="mostrarVentanaEditarInsumo"
      :width="!$vuetify.breakpoint.xs ? '700' : '90%'">
      <editar-insumo
        :insumoEditar="esteInsumo"
        v-on:cerrar="cerrarVentana">
      </editar-insumo>
    </v-dialog>
    <v-dialog
      v-if="esteInsumo"
      v-model="mostrarVentanaEliminarInsumo"
      :width="!$vuetify.breakpoint.xs ? '450' : '90%'">
      <eliminar-insumo
        :insumoEliminar="esteInsumo"
        v-on:cerrar="cerrarVentana">
      </eliminar-insumo>
    </v-dialog>
  </div>
</template>

<script>
import CATALOGO_INSUMOS from '@/graphql/querys/administracion/catalogos/insumos/catalogoInsumos.gql';
import TituloToolBar from '@/components/TituloToolBar.vue';
import RegistrarNuevoInsumo from '@/components/administracion/configuracion/catalogos/insumos/Nuevo.vue';
import EditarInsumo from '@/components/administracion/configuracion/catalogos/insumos/Editar.vue';
import EliminarInsumo from '@/components/administracion/configuracion/catalogos/insumos/Eliminar.vue';
import ToolBar from './ToolBar.vue';
import Listado from './listado/Main.vue';
import eventBus from '@/helpers/eventBus';

export default {
  name: 'CatalogoInsumosDefault',
  components: {
    TituloToolBar,
    RegistrarNuevoInsumo,
    EditarInsumo,
    EliminarInsumo,
    ToolBar,
    Listado,
  },
  apollo: {
    catalogoInsumos: {
      query: CATALOGO_INSUMOS,
    },
  },
  data() {
    return {
      mostrarVentanaRegistrarNuevoInsumo: false,
      mostrarVentanaEditarInsumo: false,
      mostrarVentanaEliminarInsumo: false,
      esteInsumo: null,
      filtros: {
        buscarTexto: '',
      },
    };
  },
  mounted() {
    eventBus.$on('editar-insumo', (insumo) => {
      this.esteInsumo = insumo;
      this.mostrarVentanaEditarInsumo = true;
    });
    eventBus.$on('eliminar-insumo', (insumo) => {
      this.esteInsumo = insumo;
      this.mostrarVentanaEliminarInsumo = true;
    });
  },
  methods: {
    registrarNuevoInsumo() {
      this.mostrarVentanaRegistrarNuevoInsumo = true;
    },
    cerrarVentana() {
      this.mostrarVentanaRegistrarNuevoInsumo = false;
      this.mostrarVentanaEditarInsumo = false;
      this.mostrarVentanaEliminarInsumo = false;
      this.esteInsumo = null;
    },
  },
  computed: {
    getCatalogoInsumos() {
      if (!this.catalogoInsumos) return [];
      return this.catalogoInsumos
      // Filtrar por Texto de Busqueda
        .filter((insumo) => {
          if (!this.filtros.buscarTexto) return insumo;
          const expt = new RegExp(this.filtros.buscarTexto, 'gi');
          const descripcion = this.$normalizacionTexto(insumo.descripcion);
          return (
            expt.test(descripcion)
            || expt.test(insumo.descripcion)
          );
        })
        .sort((a, b) => a.orden - b.orden);
    },
  },
};
</script>

<style lang="scss">

</style>
